import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

/**
 * A component to display a loading state with an optional message
 *
 * @param {Object} props
 * @param {string} props.message - Optional message to display
 * @param {number} props.size - Size of the loading indicator (default: 40)
 * @param {Object} props.sx - Additional styles to apply
 */
const LoadingState = ({ message = "Loading...", size = 40, sx = {} }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        py: 4,
        ...sx,
      }}
    >
      <CircularProgress size={size} />
      {message && (
        <Typography variant="body1" color="text.secondary" sx={{ mt: 2 }}>
          {message}
        </Typography>
      )}
    </Box>
  );
};

export default LoadingState;
